import { useClassesSubjectsShell } from '@hooks/tenant/classesSubjects/useClassesSubjectsShell';
import ClassesSubjectsView from './ClassesSubjectsView';

/** Route entry: composes shell hook + view (UI-only in `ClassesSubjectsView.jsx`). */
export default function ClassesSubjects() {
    return <ClassesSubjectsView {...useClassesSubjectsShell()} />;
}
